module.exports = __webpack_public_path__ + "images/red.c26593f29ef5806f0a2dc0963c3b03e2.png";